export default __webpack_public_path__ + "static/media/nuestraibague.08f60ef8.jpg";